module.exports = __webpack_public_path__ + "static/media/map.532f350e.svg";